import DateFormatter from "../../utils/DateFormatter";

const getCountryISO2 = require("country-iso-3-to-2");

export default class Transaction {
    constructor(jsonResponse) {
        this.transactionId = jsonResponse["transaction-id"];
        this.registrationId = jsonResponse["registration-id"];
        this.date = jsonResponse["date"];
        this.total = jsonResponse["total"];
        this.vat = jsonResponse["vat"];
        this.fees = jsonResponse["fees"];
        this.dollarAmount = jsonResponse["dollar-amount"];
        this.exchangeRate = jsonResponse["exchange-rate"];
        this.destinationAmount = jsonResponse["destination-amount"];
        this.destinationCurrency = jsonResponse["destination-currency"];
        this.destinationCountry = jsonResponse["destination-country"];
        this.status = jsonResponse["status"];
        this.remittancePartner = jsonResponse["remittance-partner"];
        this.remittanceBrandTransactionId = jsonResponse["remittance-brand-transaction-id"];
        this.remittanceBrandReferenceNumber = jsonResponse["remittance-brand-reference-number"];
        this.paymentReference = jsonResponse["payment-reference"];
        this.receiverReferenceNumber = jsonResponse["receiver-reference-number"];
        this.beneficiaryCountry = jsonResponse["beneficiary-country"];
        this.beneficiaryFirstName = jsonResponse["beneficiary-first-name"];
        this.beneficiaryLastName = jsonResponse["beneficiary-last-name"];
        this.customerFirstName = jsonResponse["customer-first-name"];
        this.customerLastName = jsonResponse["customer-last-name"];
        this.customerMsisdn = jsonResponse["customer-msisdn"];
        this.customerDateOfBirth = jsonResponse["customer-date-of-birth"];

        this.beneficiaryFullName = this.beneficiaryFirstName + " " + this.beneficiaryLastName;

        this.displayDestinationAmount = this.destinationCurrency + " " + this.destinationAmount;

        this.displayDate = DateFormatter.FormatTransactionCardDate(this.date);

        this.beneficiaryCountryISO2 =  getCountryISO2(this.beneficiaryCountry).toLowerCase()
    }


}
